import React from 'react';
import { Box, Typography, Select, MenuItem, FormControl } from '@mui/material';
import { datePickerStyles } from '../DatePicker/DatePicker.styles';

const GuestSelector = ({ value, onChange, title, icon, placeholder = 'Select' }) => {
  const guestOptions = Array.from({ length: 12 }, (_, i) => i + 1);

  const displayValue = value ? `${value} ${value === 1 ? 'Guest' : 'Guests'}` : placeholder;

  return (
    <Box sx={datePickerStyles.container}>
      <Box sx={datePickerStyles.inputContainer}>
        <Box sx={datePickerStyles.iconContainer}>{icon}</Box>
        <Box sx={datePickerStyles.textContainer}>
          <Typography sx={datePickerStyles.title}>{title}</Typography>
          <Typography
            sx={datePickerStyles.subtitle}
            fontWeight={value ? 500 : 400}
          >
            {displayValue}
          </Typography>
        </Box>
      </Box>
      <FormControl sx={datePickerStyles.hiddenInput}>
        <Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
        >
          {guestOptions.map((num) => (
            <MenuItem key={num} value={num}>
              {num} {num === 1 ? 'Guest' : 'Guests'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default GuestSelector;

